import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CancelAccountDialog } from "@/components/settings/CancelAccountDialog";
import { PlaceholderSection } from "@/components/settings/PlaceholderSection";

export function SecuritySection() {
  const [cancelOpen, setCancelOpen] = useState(false);

  return (
    <div className="flex flex-col gap-6">
      <PlaceholderSection id="security" title="Sign-in and security" description="Your password and how you sign in." icon={<ShieldCheck />} />

      <Card className="border-destructive/40 shadow-none" data-testid="danger-zone">
        <CardHeader>
          <CardTitle className="text-base">Cancel account</CardTitle>
          <CardDescription>Permanently delete your account and everything in it. This cannot be undone.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button variant="destructive" onClick={() => setCancelOpen(true)} data-testid="button-cancel-account">
            Cancel account
          </Button>
        </CardContent>
      </Card>

      <CancelAccountDialog open={cancelOpen} onOpenChange={setCancelOpen} />
    </div>
  );
}
